const PaymentCancel = () => {
  return (<div style={{padding:'50px'}}>
    <h1>Cancelled</h1>
    </div>
  );
}

export default PaymentCancel